import { type RefObject, useEffect } from 'react';
import { useIntersectionObserver } from '@fiverr-private/hooks';

export const useVideoViewportPlayback = (videoRef: RefObject<HTMLVideoElement>, src?: string) => {
    const videoIntersection = useIntersectionObserver(videoRef, { threshold: 0.5 });
    const isVideoInView = Boolean(videoIntersection?.isIntersecting);

    // Play only once the video is scrolled into view, and pause when it's
    // scrolled away. Depends on src too so playback resumes after a source
    // reload elsewhere (e.g. useVideoSourceReload), since load() resets
    // playback to paused.
    useEffect(() => {
        const video = videoRef.current;
        if (!video) {
            return;
        }

        if (isVideoInView) {
            video.play().catch(() => undefined);
        } else {
            video.pause();
        }
    }, [isVideoInView, src]);

    return isVideoInView;
};
